import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-checkmark-loader',
  templateUrl: './checkmark-loader.component.html',
  styleUrls: ['./checkmark-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckmarkLoaderComponent {
  @Input()
  @HostBinding('attr.data-loading')
  loading!: boolean;

  @Input() styleCss?: {
    width?: string;
    height?: string;
    logoWidth?: string;
    logoHeight?: string;
  };

  @HostBinding('attr.style')
  public get valueAsStyle(): any {
    const cssValues = `
      --width: ${this.styleCss?.width ?? '8rem'};
      --height: ${this.styleCss?.height ?? '8rem'};
      --logoWidth: ${this.styleCss?.logoWidth ?? '3.5em'};
      --logoHeight: ${this.styleCss?.logoHeight ?? '3em'};`;
    return this.sanitizer.bypassSecurityTrustStyle(cssValues);
  }

  constructor(private readonly sanitizer: DomSanitizer) {}
}

@NgModule({
  imports: [CommonModule, MatIconModule],
  declarations: [CheckmarkLoaderComponent],
  exports: [CheckmarkLoaderComponent],
})
export class CheckmarkLoaderModule {}
